export default __webpack_public_path__ + "static/12-322c083456af7ef984c21a77ef0fa4c8.jpg";